import { useTheme } from "@/components/admin/use-theme";
import { Button } from "@/components/ui/button";
import { Item, ItemGroup, ItemTitle } from "@/components/ui/item";
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import { LogOut, Moon, Smartphone, Sun } from "lucide-react";
import { Translate, useAuthProvider, useLogout, useTranslate } from "ra-core";

import { MobileContent } from "../layout/MobileContent";
import MobileHeader from "../layout/MobileHeader";
import { ProfilePage } from "./ProfilePage";

// ponytail: le profil (avatar, nom, email, langue, mot de passe, MCP, inbound)
// est rendu par ProfilePage, le même composant que le desktop. Ici il ne
// reste que ce que le desktop n'a pas : thème + déconnexion.
export const SettingsPageMobile = () => {
  const translate = useTranslate();
  const authProvider = useAuthProvider();
  const logout = useLogout();

  if (!authProvider) return null;

  return (
    <>
      <MobileHeader>
        <h1 className="text-xl font-semibold">
          {translate("crm.settings.title")}
        </h1>
      </MobileHeader>
      <MobileContent>
        <div className="flex flex-col min-h-[calc(100dvh-3.5rem-4.5rem)]">
          <div className="space-y-6">
            <ProfilePage />
            <ThemeRow />
          </div>

          <div className="mt-auto pt-6 space-y-3 mb-4">
            <Button
              variant="destructive"
              className="w-full text-base h-auto"
              onClick={() => logout()}
            >
              <LogOut className="size-5 mr-3" />
              <Translate i18nKey="ra.auth.logout">Log out</Translate>
            </Button>
          </div>
        </div>
      </MobileContent>
    </>
  );
};

SettingsPageMobile.path = "/settings";

const ThemeRow = () => {
  const translate = useTranslate();
  const { theme, setTheme } = useTheme();

  return (
    <div>
      <p className="text-xs font-medium text-muted-foreground uppercase tracking-wide px-1 mb-1.5">
        {translate("crm.settings.preferences", { _: "Preferences" })}
      </p>
      <ItemGroup className="rounded-lg border overflow-hidden">
        <Item size="sm" className="flex-col items-stretch gap-2">
          <ItemTitle className="font-normal text-muted-foreground">
            {translate("crm.theme.label", { _: "Theme" })}
          </ItemTitle>
          <ToggleGroup
            type="single"
            value={theme}
            onValueChange={(value) =>
              value && setTheme(value as "light" | "dark" | "system")
            }
            size="lg"
            variant="outline"
            className="w-full"
          >
            <ToggleGroupItem
              value="system"
              aria-label={translate("crm.theme.system")}
              className="flex-1 gap-2"
            >
              <Smartphone className="size-4" />
              {translate("crm.theme.system")}
            </ToggleGroupItem>
            <ToggleGroupItem
              value="light"
              aria-label={translate("crm.theme.light")}
              className="flex-1 gap-2"
            >
              <Sun className="size-4" />
              {translate("crm.theme.light")}
            </ToggleGroupItem>
            <ToggleGroupItem
              value="dark"
              aria-label={translate("crm.theme.dark")}
              className="flex-1 gap-2"
            >
              <Moon className="size-4" />
              {translate("crm.theme.dark")}
            </ToggleGroupItem>
          </ToggleGroup>
        </Item>
      </ItemGroup>
    </div>
  );
};
